import { connect } from 'react-redux';
import PrimaryStep6 from './PrimaryStep6';
import { editBatchApplySequence } from '../../store/sequencingWizardSlice';

export default connect(null, { editBatchApplySequence })(PrimaryStep6);
